/**
 * Custom checkout — układ zgód przy przycisku zamówienia.
 *
 * Desktop (>980px): tekst akceptacji regulaminu przenosimy tuż pod „Zamawiam i płacę” w podsumowaniu, a podsumowanie
 * dostaje ujemny `top`, gdy jest wyższe od ekranu, żeby przycisk zawsze dało się zobaczyć.
 * Mobile: przyklejony przycisk przy niezaznaczonych zgodach najpierw przewija do nich; na końcu formularza dostaje
 * `is-docked` i wygląda jak zwykły przycisk.
 * Bez JS zgody zostają w lewej kolumnie, nad przyciskiem mobilnym.
 */

const DESKTOP = '(min-width: 981px)';

export function initCheckoutLayout() {
    const form = document.querySelector('form.checkout.hn-co');
    if (!form) return;
    const terms = form.querySelector('[data-hn-co-section="terms"]');
    const slot = form.querySelector('[data-hn-co-terms-slot]');
    const home = terms && terms.parentElement;
    const homeNext = terms && terms.nextElementSibling;
    const col = form.querySelector('.hn-co__summary-col');
    const summary = form.querySelector('[data-hn-co-summary]');
    const mq = window.matchMedia(DESKTOP);

    const place = () => {
        if (!terms || !slot || !home) return;
        if (mq.matches) {
            if (terms.parentElement !== slot) slot.appendChild(terms);
        } else if (terms.parentElement !== home) {
            home.insertBefore(terms, homeNext);
        }
    };

    const fitSticky = () => {
        if (!col || !summary) return;
        if (!mq.matches) {
            col.style.top = '';
            return;
        }
        col.style.top = `${Math.min(80, window.innerHeight - summary.offsetHeight - 16)}px`;
    };

    place();
    fitSticky();
    mq.addEventListener('change', () => { place(); fitSticky(); });
    window.addEventListener('resize', fitSticky);
    if (summary && window.ResizeObserver) new ResizeObserver(fitSticky).observe(summary);

    // Znacznik tuż pod przyciskiem: widoczny = przycisk stoi na swoim miejscu, nie wisi przy krawędzi ekranu.
    const mobileBtn = form.querySelector('.hn-co__submit--mobile');
    if (mobileBtn && window.IntersectionObserver) {
        const marker = document.createElement('div');
        marker.setAttribute('aria-hidden', 'true');
        mobileBtn.after(marker);
        new IntersectionObserver(([entry]) => {
            mobileBtn.classList.toggle('is-docked', entry.isIntersecting);
        }).observe(marker);
    }

    // Przyklejony przycisk mobilny: niezaznaczone zgody poza ekranem → przewiń do nich zamiast błędu.
    form.addEventListener('submit', (e) => {
        if (e.target !== form || mq.matches || !terms) return;
        const unchecked = [...terms.querySelectorAll('[data-hn-co-required-consent] input[type="checkbox"]')].find((c) => !c.checked);
        if (!unchecked) return;
        const r = terms.getBoundingClientRect();
        if (r.top >= 0 && r.bottom <= window.innerHeight) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        terms.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => unchecked.focus({ preventScroll: true }), 350);
        form.dispatchEvent(new CustomEvent('hn-co-validation-failed', { bubbles: false }));
    }, true);
}
